import { Box } from "@mui/material";
import Head from "next/head";
import { useRouter } from "next/router";
import { useContext, useEffect, useState } from "react";
import LoanFormPopupV2 from "../../../../src/Drawer/LoanFormPopupV2";
import { SecondaryHeader } from "../../../../src/components/common";
import PricingSelectCityModal from "../../../../src/components/PricingPage/PricingSelectCityModal";
import FAQ from "../../../../src/SDK/FAQ/faq";
import TurnoPromiseComponent from "../../../../src/SDK/FAQ/turnoPromiseComponent";
import { vehicleFAQs } from "../../../../src/constants/brandFaqs";
import { newVehicles, vehicles } from "../../../../src/constants/vehicleData";
import { keySpecificationsInfo } from "../../../../src/constants/vehicleKeySpec";
import { vehiclePromiseList } from "../../../../src/constants/vehiclesPromises";
import { imagesWEBP } from "../../../../src/constants/webpImages";
import { Context } from "../../../../src/context/context";
import { MemoizedFooter } from "../../../../src/layouts/footer";
import { MemoizedHeader } from "../../../../src/layouts/header";
import NewVehicleReview from "../../../../src/modules/Home/BrandExp/NewVehicleReview";
import BookVehicleDrawer from "../../../../src/modules/Home/Drawer/bookVehicleDrawer";
import MemoizedKeySpecifications from "../../../../src/modules/Home/VehiclesV2/KeySpecifications";
import ProductTopBanner from "../../../../src/modules/Home/VehiclesV2/ProductTopBanner";
import MemoizedVehicleFeatures from "../../../../src/modules/Home/VehiclesV2/VehicleFeatures";
import VehicleLatestList from "../../../../src/modules/Home/VehiclesV2/VehicleLatestList";
import VehicleSpecificUseSwiper from "../../../../src/modules/Home/VehiclesV2/VehicleSpecificUses";
import WebShare from "../../../../src/modules/Lead Capture/WebShare.jsx/WebShare";
import QlDrawerComponent from "../../../../src/modules/LeadDataCollection/DrawerComponents/LoanDrawerComponents";
import HeaderDesc from "../../../../src/modules/Vehicles/Banner/HeaderDesc";
import MemoizedBrandDealerNear from "../../../../src/modules/Vehicles/BrandDealerNear";
import PricingPopularCities from "../../../../src/components/PricingPage/PricingPopularCities";
import { MemoizedLeadCaptureV2 } from "../../../../src/pages/LeadCapture/LeadCaptureV2";
import { sendAnalytics } from "../../../../src/utils/analyticsCommon";
import { useMobile } from "../../../../src/utils/findViewport";
import MemoizedSearchHeader from "../../../../src/modules/Vehicles/searchHeader.jsx";
import {
  generateProductSchema,
  createOffer,
  createBrand,
  createPropertyValue,
} from "../../../../src/utils/ProductSchemaGenerator.js";
import {
  generateFAQPageSchema,
  convertFAQsToQuestions,
} from "../../../../src/utils/FAQPageSchemaGenerator.js";
import {
  TITLE,
  META_CONTENT,
  VEHICLE_LINK,
  KEY_SPECIFICATION_HEADER,
  HIGHLIGHTS_HEADING,
  HIGHLIGHTS_DESCRIPTION,
  MOSTLY_BOUGHT_FOR_HEADING,
  BUSINESS_BENEFIT_HEADING,
  FEATURES_HEADING,
  BRAND_DEALER_HEADING,
  BRAND_DEALER_DESCRIPITION,
  FAQ_HEADING_TEXT,
  BREADCRUMB_ITEMS,
  BREADCRUMB_SCHEMA,
} from "../../../../src/constants/electricCommericalVehicle/Etrio/turoMax.js";
import Breadcrumbs from "../../../../src/components/common/Breadcrumbs";

const PRICE_CITIES = [
  "pune",
  "mumbai",
  "bangalore",
  "hyderabad",
  "chennai",
  "kolkata",
  "delhi-ncr",
  "jaipur",
  "lucknow",
  "ahmedabad",
  "indore",
];

export default function VehicleModelDetails({
  brand,
  vehicleModel,
  vehicleDataLocal,
  plusIcons,
  latestVehiclesInfo,
  productSchema,
  faqPageSchema,
}) {
  const noentryData = [
    {
      id: 1,
      imageName: imagesWEBP?.businesstouroMax1,
      // title: "Use your Cargo EV across Delhi Without Restrictions",
    },
    {
      id: 2,
      imageName: imagesWEBP?.businesstouroMax2,
      // title:
      //   "No 7 AM to 11 AM and 5PM to 9PM Restrictions for ELECTRIC VEHICLES IN Delhi",
    },
    {
      id: 3,
      imageName: imagesWEBP?.businesstouroMax3,
      // title: "Benefit from Govt. Relaxation for EVs",
    },
    {
      id: 4,
      imageName: imagesWEBP?.businesstouroMax4,
      // title: "Benefit from Govt. Relaxation for EVs",
    },
  ];

  const useCaseData = [
    {
      id: 1,
      imageName: imagesWEBP?.touroMaxusecase0,
      title: "Use your Cargo EV across Delhi Without Restrictions",
    },
    {
      id: 2,
      imageName: imagesWEBP?.touroMaxusecase1,
      title:
        "No 7 AM to 11 AM and 5PM to 9PM Restrictions for ELECTRIC VEHICLES IN Delhi",
    },
    {
      id: 3,
      imageName: imagesWEBP?.touroMaxusecase2,
      title: "Benefit from Govt. Relaxation for EVs",
    },
    {
      id: 3,
      imageName: imagesWEBP?.touroMaxusecase3,
      title: "Benefit from Govt. Relaxation for EVs",
    },
  ];

  const images = [
    {
      original: imagesWEBP?.rating1,
    },
    {
      original: imagesWEBP?.rating2,
    },
    {
      original: imagesWEBP?.rating3,
    },
    { original: imagesWEBP?.rating4 },
  ];

  const isMobile = useMobile();
  useEffect(() => {
    sendAnalytics(
      "screen_viewed",
      { screen_name: `electric_commercial_vehicle_${brand}_${vehicleModel}` },
      "en"
    );
  }, [brand, vehicleModel]);

  const state = useContext(Context);
  const router = useRouter();
  const [priceCityModalOpen, setPriceCityModalOpen] = useState(false);
  const [activeSectionId, setActiveSectionId] = useState("section-header");
  let location =
    state?.selectedState === "Others" ? "India" : state?.selectedState;

  const handlePriceCitySelect = (citySlug) => {
    setPriceCityModalOpen(false);
    router.push(`/electric-commercial-vehicles/Etrio/Touro-MAX/price/${citySlug}`);
  };

  const secondaryHeaderItems = [
    { label: "Etrio Touro MAX", sectionId: "section-header" },
    {
      label: "Price",
      sectionId: "section-price",
      onClick: () => setPriceCityModalOpen(true),
    },
    { label: "Specification", sectionId: "section-specification" },
    { label: "Summary", sectionId: "section-summary" },
  ];

  return (
    <>
      <Head>
        <title>{TITLE}</title>
        {META_CONTENT.map((meta, index) => (
          <meta
            key={index}
            {...(meta.name ? { name: meta.name } : { property: meta.property })}
            content={meta.content}
          />
        ))}
        <link rel="canonical" href={VEHICLE_LINK} />
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html: JSON.stringify(BREADCRUMB_SCHEMA),
          }}
          defer
        />
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html: JSON.stringify(productSchema),
          }}
          defer
        />
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html: JSON.stringify(faqPageSchema),
          }}
          defer
        />
      </Head>
      <Box>
      <Box sx={{ display: { xs: "none", md: "block" } }}>
        <MemoizedHeader scrollWithPage={true} />
      </Box>
      <Box sx={{ display: { xs: "block", md: "none" } }}>
        <MemoizedSearchHeader isProductPage={true} />
      </Box>
      <SecondaryHeader
        items={secondaryHeaderItems}
        activeSectionId={activeSectionId}
        onActiveSectionChange={setActiveSectionId}
        scrollOffsetTop={100}
      />
      <PricingSelectCityModal
        isOpen={priceCityModalOpen}
        onClose={() => setPriceCityModalOpen(false)}
        currentCitySlug={null}
        availableCities={PRICE_CITIES}
        onSelectCity={handlePriceCitySelect}
      />
      {/* Main component */}
      {/* <Box id="section-header" sx={{ display: { xs: "none", md: "block" }, background: "#F3F3F4" }}>
        <ProductTopBanner
          location={location}
          vehicle_name={"E- Trio Touro Max"}
        />
      </Box> */}
      <Box
        sx={{
          position: "relative",
          width: "100%",
        }}
      >
        <Box
          sx={{
            position: "absolute",
            top: "0",
            left: "0",
            zIndex: "120",
            display: { xs: "block", md: "none" },
            width: "100%",
          }}
        >
          <WebShare vehicleData={vehicleDataLocal[0]} />
          <BookVehicleDrawer />
        </Box>
      </Box>
      <Box id="section-price">
        <MemoizedLeadCaptureV2 vehicleDataLocal={vehicleDataLocal} />
      </Box>

      {/* <HeaderDesc
        HeadingTag="h2"
        heading="Etrio Touro Max ++"
        subText="Mahindra Treo  Zor electric auto has a clutchless automatic transmission, which gives you a noiseless and vibration-free drive. It comes with a lithium-ion battery that lasts more than 1.5 lakh km, the Nemo app for real-time performance tracking, and a range of variants to suit all your needs. Priced between X and X lakhs, this electric cargo three-wheeler will keep you on the go. Here are a few more reasons why you should get this electric three-wheeler tempo:
"
      /> */}

      <Box id="section-specification">
        <MemoizedKeySpecifications
          keySpecifications={keySpecificationsInfo?.touroMax}
          headerInfo={KEY_SPECIFICATION_HEADER}
        />
      </Box>

      <Box id="section-summary">
      <HeaderDesc
        HeadingTag="h2"
        heading={HIGHLIGHTS_HEADING}
        subText={HIGHLIGHTS_DESCRIPTION}
      />

      <HeaderDesc
        HeadingTag="h2"
        heading={MOSTLY_BOUGHT_FOR_HEADING}
        //subText="The Etrio Touro Max ++, with its impressive payload capacity and efficient range, finds utility in various commercial and logistical scenarios. Here are some use cases where the Treo Zor could be a valuable asset for,"
      />
      </Box>

      <VehicleSpecificUseSwiper
        slidePerView={4}
        data={useCaseData}
        isHeader={false}
        isTitle={false}
        //headerInfo={`Business Benefit with Electric Vehicle`}
      />

      <VehicleSpecificUseSwiper
        slidePerView={4}
        data={noentryData}
        headerInfo={BUSINESS_BENEFIT_HEADING}
      />

      <MemoizedVehicleFeatures
        promisesData={vehiclePromiseList?.touroMax}
        headerInfo={FEATURES_HEADING}
      />

      <MemoizedBrandDealerNear
        BannerDealerData={{
          headerInfo: BRAND_DEALER_HEADING,
          description: BRAND_DEALER_DESCRIPITION,
          desktopImg: imagesWEBP?.locationBanner,
          mobileImg: imagesWEBP?.multibrandstore,
        }}
      />

      <PricingPopularCities
        vehicleBrand={brand}
        vehicleName={vehicleDataLocal?.[0]?.vehicle_name || vehicleDataLocal?.[0]?.name || "Touro MAX"}
        brand={brand}
        model={vehicleModel}
      />

      <Box
        sx={{
          width: "100vw",
          alignItems: "center",
          flexDirection: "column",
          paddingLeft: { xs: "10px", sm: "8%", md: "8%", lg: "8%" },
          paddingRight: { xs: "10px", sm: "8%", md: "8%", lg: "8%" },
          marginTop: "48px",
          paddingTop: "12px",
        }}
      >
        <TurnoPromiseComponent />
        <NewVehicleReview images={images} slidesPerView={isMobile ? 1.4 : 4} />
        <VehicleLatestList latestVehiclesInfo={latestVehiclesInfo} />

        <Box
          sx={{ padding: { xs: "10px", sm: "10px", md: "20px", lg: "20px" } }}
        >
          <FAQ
            faqList={vehicleFAQs?.touroMax}
            showItems={5}
            headText={FAQ_HEADING_TEXT}
          />
        </Box>

        <LoanFormPopupV2 />
        <QlDrawerComponent />
        <Box
          sx={{
            width: { xs: "100%", md: "84%" },
            margin: "20px auto",
            padding: { xs: "0 12px", md: "0" },
          }}
        >
          <Breadcrumbs items={BREADCRUMB_ITEMS} />
        </Box>
      </Box>

      <MemoizedFooter />
      </Box>
    </>
  );
}

export const getStaticProps = (context) => {
  let vehicleData = [...vehicles, ...newVehicles];

  const brand = "Etrio";
  const vehicleModel = "Touro-MAX";

  let vehicleDataLocal = vehicleData?.filter(function (vehicle) {
    return vehicle?.vehicle_path_id === `${vehicleModel}`;
  });

  let latestVehiclesInfo = vehicleData?.filter((vehicle) => {
    return vehicle?.vehicle_path_id !== `${vehicleModel}`;
  });

  // Constants are already imported at the top of the file

  // Generate Product Schema
  const vehicleDataItem = vehicleDataLocal?.[0];
  const productImages = vehicleDataItem?.images_287 || [
    imagesWEBP?.touroMaxImage1,
    imagesWEBP?.touroMaxImage2,
    imagesWEBP?.touroMaxImage3,
    imagesWEBP?.touroMaxImage4,
  ].filter(Boolean);

  // Get price range from vehicle data
  const getPriceRange = () => {
    if (!vehicleDataItem?.prices) return { lowPrice: 450000, highPrice: 500000 };
    const allPrices = [];
    Object.values(vehicleDataItem.prices).forEach((statePrices) => {
      Object.values(statePrices).forEach((variant) => {
        if (variant.price) {
          allPrices.push(variant.price * 100000); // Convert lakhs to rupees
        }
      });
    });
    return {
      lowPrice: Math.min(...allPrices),
      highPrice: Math.max(...allPrices),
    };
  };

  const priceRange = getPriceRange();

  const productSchema = generateProductSchema({
    name: "Etrio Touro Max",
    description: HIGHLIGHTS_DESCRIPTION || META_CONTENT[0]?.content,
    image: productImages,
    url: VEHICLE_LINK,
    brand: createBrand({
      name: "Etrio",
      url: "https://www.turno.club/electric-commercial-vehicles/Etrio",
    }),
    category: "Electric Commercial Vehicle",
    model: "Touro Max",
    manufacturer: {
      "@type": "Organization",
      name: "Etrio Automobiles Private Limited",
    },
    offers: createOffer({
      offerCount: 3,
      lowPrice: priceRange.lowPrice,
      highPrice: priceRange.highPrice,
      priceCurrency: "INR",
      availability: "https://schema.org/InStock",
      url: VEHICLE_LINK,
      seller: {
        "@type": "Organization",
        name: "Turno",
        url: "https://www.turno.club/",
      },
    }),
    additionalProperty: [
      vehicleDataItem?.load
        ? createPropertyValue({ name: "Load Capacity", value: vehicleDataItem.load })
        : null,
      vehicleDataItem?.range
        ? createPropertyValue({ name: "Range", value: vehicleDataItem.range })
        : null,
      vehicleDataItem?.batteryCapacity
        ? createPropertyValue({
            name: "Battery Capacity",
            value: vehicleDataItem.batteryCapacity,
          })
        : null,
      vehicleDataItem?.batteryVoltage
        ? createPropertyValue({
            name: "Battery Voltage",
            value: vehicleDataItem.batteryVoltage,
          })
        : null,
    ].filter(Boolean),
    keywords: META_CONTENT[1]?.content || "Etrio Touro Max, electric vehicle",
    mainEntityOfPage: {
      "@type": "WebPage",
      "@id": VEHICLE_LINK,
    },
    itemCondition: "https://schema.org/NewCondition",
    isFamilyFriendly: true,
    slogan: "Heavy-duty electric three-wheeler for cargo transportation",
  });

  // Generate FAQPage Schema
  const faqQuestions = convertFAQsToQuestions(vehicleFAQs?.touroMax || [], {
    url: VEHICLE_LINK,
    dateCreated: new Date().toISOString(),
    author: {
      "@type": "Organization",
      name: "Turno",
      url: "https://www.turno.club/",
    },
  });

  const faqPageSchema = generateFAQPageSchema({
    mainEntity: faqQuestions,
    name: FAQ_HEADING_TEXT || "FAQs on Etrio Touro Max",
    description: `Frequently asked questions about Etrio Touro Max electric commercial vehicle. ${HIGHLIGHTS_DESCRIPTION || ""}`,
    url: VEHICLE_LINK,
    headline: FAQ_HEADING_TEXT || "FAQs on Etrio Touro Max",
    keywords: META_CONTENT[1]?.content || "Etrio Touro Max, FAQ, electric vehicle",
    inLanguage: "en",
    publisher: {
      "@type": "Organization",
      name: "Turno",
      url: "https://www.turno.club/",
      logo: {
        "@type": "ImageObject",
        url: "https://www.turno.club/logoIcon.png",
      },
    },
    datePublished: new Date().toISOString(),
    dateModified: new Date().toISOString(),
    mainEntityOfPage: {
      "@type": "WebPage",
      "@id": VEHICLE_LINK,
    },
    breadcrumb: BREADCRUMB_SCHEMA,
    primaryImageOfPage: {
      "@type": "ImageObject",
      url: productImages[0] || "https://www.turno.club/logoIcon.png",
    },
    isFamilyFriendly: true,
    isAccessibleForFree: true,
    speakable: {
      "@type": "SpeakableSpecification",
      xPath: [
        "/html/head/title",
        "/html/head/meta[@name='description']/@content",
      ],
    },
  });

  return {
    props: { 
      brand, 
      vehicleModel, 
      vehicleDataLocal, 
      latestVehiclesInfo,
      productSchema,
      faqPageSchema,
    },
  };
};
